'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var constants = require('./constants.js');
var languageFromLocale = require('./utilities/languageFromLocale.js');

// Note: A similar Ruby implementation of this function also exists at https://github.com/Shopify/shopify-i18n/blob/main/lib/shopify-i18n/name_formatter.rb.
function formatName({
  name,
  locale,
  options
}) {
  if (!name.givenName) {
    return name.familyName || '';
  }
  if (!name.familyName) {
    return name.givenName;
  }
  const isFullName = Boolean(options && options.full);
  const customNameFormatter = constants.FAMILY_NAME_GIVEN_NAME_ORDERING_INDEXED_BY_LANGUAGE.get(languageFromLocale.languageFromLocale(locale));
  if (customNameFormatter) {
    return customNameFormatter(name.givenName, name.familyName, isFullName);
  }
  if (isFullName) {
    return `${name.givenName} ${name.familyName}`;
  }
  return name.givenName;
}

exports.formatName = formatName;
